<template>
    <div class="user-profile-container">
        <div class="page-header">
            <h2>个人中心</h2>
            <el-button type="primary" @click="goBack">返回</el-button>
        </div>

        <!-- 用户基本信息 -->
        <div class="user-info-section">
            <!-- <div class="user-avatar">
                <el-avatar :size="80" :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
                <el-button size="mini" type="text" @click="uploadAvatar">更换头像</el-button>
            </div> -->
            <div class="user-details">
                <div class="user-name">
                    <span>{{ userInfo.name || '未设置' }}</span>
                    <el-button size="mini" type="text" @click="editProfile">编辑</el-button>
                </div>
                <div class="user-phone">手机号：{{ userInfo.phone || '未绑定' }}</div>
                <div class="user-email">邮箱：{{ userInfo.email || '未绑定' }}</div>
                <div class="user-register-time">注册时间：{{ userInfo.registerTime || '2025-01-01' }}</div>
            </div>
        </div>

        <!-- 认证状态 -->
        <div class="auth-section">
            <h3>认证状态</h3>
            <div class="auth-cards">
                <!-- 个人实名认证 -->
                <div class="auth-card">
                    <div class="auth-header">
                        <div class="auth-title">
                            <i class="el-icon-user"></i>
                            <span>个人实名认证</span>
                        </div>
                        <div class="auth-status" :class="getAuthStatusClass(userInfo.personalAuth)">
                            {{ getAuthStatusText(userInfo.personalAuth) }}
                        </div>
                    </div>
                    <div class="auth-content">
                        <p v-if="userInfo.personalAuth === 'approved'">
                            已完成个人实名认证，姓名：{{ userInfo.realName }}
                        </p>
                        <p v-else-if="userInfo.personalAuth === 'pending'">
                            个人实名认证审核中，请耐心等待
                        </p>
                        <p v-else-if="userInfo.personalAuth === 'rejected'">
                            个人实名认证未通过，原因：{{ userInfo.personalAuthReason }}
                        </p>
                        <p v-else>
                            完成个人实名认证，提升账户安全性和信任度
                        </p>
                    </div>
                    <div class="auth-actions">
                        <el-button 
                            type="primary" 
                            size="small" 
                            @click="openPersonalAuth" 
                            v-if="userInfo.personalAuth !== 'approved' && userInfo.personalAuth !== 'pending'">
                            {{ userInfo.personalAuth === 'rejected' ? '重新认证' : '立即认证' }}
                        </el-button>
                        <el-button 
                            size="small" 
                            @click="viewAuthDetail('personal')" 
                            v-if="userInfo.personalAuth === 'approved'">
                            查看详情
                        </el-button>
                    </div>
                </div>

                <!-- 企业认证 -->
                <div class="auth-card">
                    <div class="auth-header">
                        <div class="auth-title">
                            <i class="el-icon-office-building"></i>
                            <span>企业认证</span>
                        </div>
                        <div class="auth-status" :class="getAuthStatusClass(userInfo.enterpriseAuth)">
                            {{ getAuthStatusText(userInfo.enterpriseAuth) }}
                        </div>
                    </div>
                    <div class="auth-content">
                        <p v-if="userInfo.enterpriseAuth === 'approved'">
                            已完成企业认证，企业：{{ userInfo.companyName }}
                        </p>
                        <p v-else-if="userInfo.enterpriseAuth === 'pending'">
                            企业认证审核中，请耐心等待
                        </p>
                        <p v-else-if="userInfo.enterpriseAuth === 'rejected'">
                            企业认证未通过，原因：{{ userInfo.enterpriseAuthReason }}
                        </p>
                        <p v-else>
                            完成企业认证，获得更多企业服务权限
                        </p>
                    </div>
                    <div class="auth-actions">
                        <el-button 
                            type="primary" 
                            size="small" 
                            @click="openEnterpriseAuth" 
                            v-if="userInfo.enterpriseAuth !== 'approved' && userInfo.enterpriseAuth !== 'pending'">
                            {{ userInfo.enterpriseAuth === 'rejected' ? '重新认证' : '立即认证' }}
                        </el-button>
                        <el-button 
                            size="small" 
                            @click="viewAuthDetail('enterprise')" 
                            v-if="userInfo.enterpriseAuth === 'approved'">
                            查看详情
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 个人实名认证弹框 -->
        <el-dialog title="个人实名认证" :visible.sync="personalAuthVisible" width="500px">
            <el-form :model="personalAuthForm" :rules="personalAuthRules" ref="personalAuthRef" label-width="100px">
                <el-form-item label="真实姓名" prop="realName">
                    <el-input v-model="personalAuthForm.realName" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                    <el-input v-model="personalAuthForm.idCard" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面" prop="idCardFront">
                    <div class="upload-area">
                        <el-upload
                            class="upload-demo"
                            drag
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-success="handleIdCardFrontSuccess"
                            :before-upload="beforeUpload"
                            :limit="1"
                            accept="image/*">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过2MB</div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="身份证反面" prop="idCardBack">
                    <div class="upload-area">
                        <el-upload
                            class="upload-demo"
                            drag
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-success="handleIdCardBackSuccess"
                            :before-upload="beforeUpload"
                            :limit="1"
                            accept="image/*">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过2MB</div>
                        </el-upload>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="personalAuthVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPersonalAuth">提 交</el-button>
            </div>
        </el-dialog>

        <!-- 企业认证弹框 -->
        <el-dialog title="企业认证" :visible.sync="enterpriseAuthVisible" width="500px">
            <el-form :model="enterpriseAuthForm" :rules="enterpriseAuthRules" ref="enterpriseAuthRef" label-width="100px">
                <el-form-item label="企业名称" prop="companyName">
                    <el-input v-model="enterpriseAuthForm.companyName" placeholder="请输入企业全称"></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="creditCode">
                    <el-input v-model="enterpriseAuthForm.creditCode" placeholder="请输入统一社会信用代码"></el-input>
                </el-form-item>
                <el-form-item label="法人姓名" prop="legalPerson">
                    <el-input v-model="enterpriseAuthForm.legalPerson" placeholder="请输入法人姓名"></el-input>
                </el-form-item>
                <el-form-item label="法人身份证" prop="legalIdCard">
                    <el-input v-model="enterpriseAuthForm.legalIdCard" placeholder="请输入法人身份证号"></el-input>
                </el-form-item>
                <el-form-item label="营业执照" prop="businessLicense">
                    <div class="upload-area">
                        <el-upload
                            class="upload-demo"
                            drag
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-success="handleBusinessLicenseSuccess"
                            :before-upload="beforeUpload"
                            :limit="1"
                            accept="image/*">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过2MB</div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="联系电话" prop="contactPhone">
                    <el-input v-model="enterpriseAuthForm.contactPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="enterpriseAuthVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEnterpriseAuth">提 交</el-button>
            </div>
        </el-dialog>

        <!-- 编辑个人信息弹框 -->
        <el-dialog title="编辑个人信息" :visible.sync="editProfileVisible" width="400px">
            <el-form :model="editProfileForm" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="editProfileForm.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="editProfileForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editProfileVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveProfile">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'UserProfile',
    data() {
        return {
            userInfo: {
                name: '小黄',
                phone: '193****3560',
                email: 'service282@163.com',
                avatar: '',
                registerTime: '2025-01-01 10:30:00',
                personalAuth: 'none', // none, pending, approved, rejected
                enterpriseAuth: 'none',
                realName: '',
                companyName: '',
                personalAuthReason: '',
                enterpriseAuthReason: ''
            },
            personalAuthVisible: false,
            enterpriseAuthVisible: false,
            editProfileVisible: false,
            personalAuthForm: {
                realName: '',
                idCard: '',
                idCardFront: '',
                idCardBack: ''
            },
            enterpriseAuthForm: {
                companyName: '',
                creditCode: '',
                legalPerson: '',
                legalIdCard: '',
                businessLicense: '',
                contactPhone: ''
            },
            editProfileForm: {
                name: '',
                email: ''
            },
            personalAuthRules: {
                realName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号码格式不正确', trigger: 'blur' }
                ]
            },
            enterpriseAuthRules: {
                companyName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' }
                ],
                creditCode: [
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法人姓名', trigger: 'blur' }
                ],
                legalIdCard: [
                    { required: true, message: '请输入法人身份证号', trigger: 'blur' }
                ],
                contactPhone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.loadUserInfo();
    },
    methods: {
        // 加载用户信息
        loadUserInfo() {
            // 模拟加载用户数据
            // 实际项目中应该调用API获取用户信息
        },

        // 获取认证状态样式类
        getAuthStatusClass(status) {
            const statusMap = {
                'none': 'status-none',
                'pending': 'status-pending',
                'approved': 'status-approved',
                'rejected': 'status-rejected'
            };
            return statusMap[status] || 'status-none';
        },

        // 获取认证状态文本
        getAuthStatusText(status) {
            const statusMap = {
                'none': '未认证',
                'pending': '审核中',
                'approved': '已认证',
                'rejected': '未通过'
            };
            return statusMap[status] || '未认证';
        },

        // 打开个人实名认证
        openPersonalAuth() {
            this.personalAuthVisible = true;
        },

        // 打开企业认证
        openEnterpriseAuth() {
            this.enterpriseAuthVisible = true;
        },

        // 查看认证详情
        viewAuthDetail(type) {
            if (type === 'personal') {
                this.$message.info('查看个人认证详情');
            } else {
                this.$message.info('查看企业认证详情');
            }
        },

        // 编辑个人资料
        editProfile() {
            this.editProfileForm.name = this.userInfo.name;
            this.editProfileForm.email = this.userInfo.email;
            this.editProfileVisible = true;
        },

        // 保存个人资料
        saveProfile() {
            this.userInfo.name = this.editProfileForm.name;
            this.userInfo.email = this.editProfileForm.email;
            this.editProfileVisible = false;
            this.$message.success('个人信息保存成功');
        },

        // 上传头像
        uploadAvatar() {
            this.$message.info('上传头像功能待实现');
        },

        // 文件上传前检查
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },

        // 身份证正面上传成功
        handleIdCardFrontSuccess(response, file) {
            this.personalAuthForm.idCardFront = file.response || file.name;
            this.$message.success('身份证正面上传成功');
        },

        // 身份证反面上传成功
        handleIdCardBackSuccess(response, file) {
            this.personalAuthForm.idCardBack = file.response || file.name;
            this.$message.success('身份证反面上传成功');
        },

        // 营业执照上传成功
        handleBusinessLicenseSuccess(response, file) {
            this.enterpriseAuthForm.businessLicense = file.response || file.name;
            this.$message.success('营业执照上传成功');
        },

        // 提交个人实名认证
        submitPersonalAuth() {
            this.$refs.personalAuthRef.validate((valid) => {
                if (valid) {
                    // 模拟提交认证
                    this.userInfo.personalAuth = 'pending';
                    this.personalAuthVisible = false;
                    this.$message.success('个人实名认证提交成功，请等待审核');
                } else {
                    this.$message.error('请完善认证信息');
                    return false;
                }
            });
        },

        // 提交企业认证
        submitEnterpriseAuth() {
            this.$refs.enterpriseAuthRef.validate((valid) => {
                if (valid) {
                    // 模拟提交认证
                    this.userInfo.enterpriseAuth = 'pending';
                    this.enterpriseAuthVisible = false;
                    this.$message.success('企业认证提交成功，请等待审核');
                } else {
                    this.$message.error('请完善认证信息');
                    return false;
                }
            });
        },

        // 返回
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.user-profile-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.page-header h2 {
    margin: 0;
    color: #333;
}

.user-info-section {
    display: flex;
    align-items: center;
    padding: 30px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
}

.user-avatar {
    text-align: center;
    margin-right: 30px;
}

.user-avatar .el-button {
    margin-top: 10px;
    color: #409EFF;
}

.user-details {
    flex: 1;
}

.user-name {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
}

.user-name .el-button {
    margin-left: 10px;
    color: #409EFF;
}

.user-phone, .user-email, .user-register-time {
    margin-bottom: 8px;
    color: #666;
    font-size: 14px;
}

.auth-section {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 30px;
}

.auth-section h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
}

.auth-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.auth-card {
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    padding: 20px;
    transition: box-shadow 0.3s ease;
}

.auth-card:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.auth-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.auth-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #333;
}

.auth-title i {
    margin-right: 8px;
    font-size: 18px;
}

.auth-status {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.status-none {
    background-color: #f5f5f5;
    color: #999;
}

.status-pending {
    background-color: #fff7e6;
    color: #fa8c16;
}

.status-approved {
    background-color: #f6ffed;
    color: #52c41a;
}

.status-rejected {
    background-color: #fff2f0;
    color: #ff4d4f;
}

.auth-content {
    margin-bottom: 16px;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

.auth-actions {
    text-align: right;
}

.upload-area {
    margin-top: 8px;
}

.upload-demo {
    width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .user-profile-container {
        padding: 10px;
    }
    
    .user-info-section {
        flex-direction: column;
        text-align: center;
    }
    
    .user-avatar {
        margin-right: 0;
        margin-bottom: 20px;
    }
    
    .auth-cards {
        grid-template-columns: 1fr;
    }
}
</style> 